import { PureComponent } from 'react'
import type { PublicProps as Props } from './typings'

import CustomFieldsList from './CustomFieldsList'
import { CUSTOM_FIELD_MAX_LENGTH } from './components/constants'

interface State {
  suggestions: string[]
  filter: string
  isMaxCharacterCountExceeded: boolean
}

const computeSuggestions = (props: Props, filter: string): string[] => {
  const { value, suggestions } = props
  const keysToFilter = Object.keys(value)

  const acc: string[] = []

  suggestions.forEach((s: string) => {
    const isAlreadyUsed: boolean = keysToFilter.includes(s)
    const isIncludedInFilter: boolean = s.startsWith(filter)

    if (!isAlreadyUsed && isIncludedInFilter) {
      acc.push(s)
    }
  })

  return acc
}

const setFilter = (filter: string) => () => ({
  filter,
})

const setSuggestions = (suggestions: string[]) => () => ({
  suggestions,
})

const setIsMaxCharacterCountExceeded = (value: string) => () => ({
  isMaxCharacterCountExceeded: value.length > CUSTOM_FIELD_MAX_LENGTH,
})

export default class CustomFieldsListContainer extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      suggestions: computeSuggestions(props, ''),
      filter: '',
      isMaxCharacterCountExceeded: false,
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const { value: prevValue, suggestions: prevSuggestions } = prevProps
    const { value, suggestions } = this.props
    const { filter: prevFilter } = prevState
    const { filter } = this.state

    if (prevValue !== value || prevSuggestions !== suggestions || filter !== prevFilter) {
      this.setState(setSuggestions(computeSuggestions(this.props, filter)))
    }
  }

  private handleOnChangeFilter = (filter: string) => {
    this.setState(setIsMaxCharacterCountExceeded(filter))
    this.setState(setFilter(filter))
  }

  render() {
    const { filter } = this.state
    const { suggestions, ...props } = this.props
    const { suggestions: stateSuggestions, isMaxCharacterCountExceeded } = this.state

    return (
      <CustomFieldsList
        {...props}
        suggestions={stateSuggestions}
        onChangeFilter={this.handleOnChangeFilter}
        filter={filter}
        isMaxCharacterCountExceeded={isMaxCharacterCountExceeded}
      />
    )
  }
}
